import { createFileRoute } from "@tanstack/react-router"

import { signOutFn } from "~/modules/auth/auth.functions"

export const Route = createFileRoute("/auth/sign-out")({
  preload: false,
  loader: () => signOutFn(),
})
